module.exports = __webpack_public_path__ + "static/media/TCPlogo.92a09b40.svg";